<template>
    <div class="checkout relative">
    <VivaLoader />
    <HeaderDashboard />
       <div>
        <main class="checkout-component h-screen bg-gray-50 pt-24 md:pt-36 pb-10">
            <div>
                
                <div class=" flex flex-col md:flex-row max-w-7xl mx-auto container">
                    <DashboardSidebarMenu isPage="suscripción"/>
                    <div class="main-content w-full md:w-4/5 flex flex-col xs:pt-4">
                        <section class="mb-5">
                            <div class="max-w-6xl mx-auto px-4" v-if="subscription">
                                <DashboardUserCardInformation />
                            </div>
                        </section>
                        
                        <section class="mb-5">
                            <div class="max-w-6xl mx-auto px-4" v-if="subscription">
                                <DashboardTeamCardInformation />
                            </div>
                        </section>
                        <section class="mb-5">
                            <div class="text-center p-10">
                                <div>{{dashboardTranslate[language].information.text }} </div>
                                <div><a :href="`mailto:${dashboardTranslate[language].information.email}`" class="text-green-400 font-semibold">{{dashboardTranslate[language].information.email }} </a></div>
                            </div>
                        </section>
                    </div>
                </div>
                <ModalNoBilling :show="isShow" @close="closeBilling"/>
                <div class="lg:pt-44 md:pt-16">
                    <FooterCheckout />
                </div>
            </div>
        </main>
       </div>
    </div>
</template>

<script>
import HeaderDashboard from "@/components/header/Header.vue"
import FooterCheckout from "@/components/Footer.vue"
import DashboardSidebarMenu from "@/components/dashboard/SidebarMenu.vue"
import VivaLoader from "@/components/loader/Loader.vue"
import DashboardUserCardInformation from '@/components/dashboard/UserCardInformation.vue'
import DashboardTeamCardInformation from '@/components/dashboard/TeamCardInformation.vue'
import ModalNoBilling from '@/components/modals/ModalNoBilling.vue'
import { modalTranslation } from '@/translations/Modals.js'
import { dashboardTranslate } from '@/translations/Dashboard.js'
import { dataLayerViewCard } from '@/pixels/datalayer.js'

import { computed, onMounted, ref, watch } from "@vue/runtime-core"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
export default({
    name: 'Suscripción',
    components: {
        HeaderDashboard,
        FooterCheckout,
        DashboardSidebarMenu,
        VivaLoader,
        DashboardUserCardInformation,
        DashboardTeamCardInformation,
        ModalNoBilling
    },
    data() {
        return {
            imgA: require('@/assets/img/dashboard/team-upgrade-membresía.png'),
            imgB: require('@/assets/img/dashboard/individual-upgrade-membresía.png')
        }
    },
    setup(){
        
        const isShow = ref(false)
        const showModalActive = ref(false)
        const store = useStore()
        const router = useRouter()
        const currentCompanions =ref(0)
        const currentPlan = computed(() =>{
            return store.state.Plans.data  ? store.state.Plans.data : []
        })
        const isExpiredCompanions = ref(false)
            const language = computed( ()=> {
                return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
            })
        const subscription = computed(() => {
            return store.state.Checkout.data.userSubscription.data
        })
        const hasBilling = computed( () =>{
            return store.state.Checkout.data.userSubscription.data ? 
                    Object.keys(store.state.Checkout.data.userSubscription.data.billing).length > 0 ? true : false
                : false
        })

        const currency = computed(() => {
            return  localStorage.getItem('viva-currency') ? localStorage.getItem('viva-currency') : 'MXN';
        })


        const account = computed(() =>{
            return store.state.Accounts.data
        })

        const  onShowModalActivate = ( value ) => {
         showModalActive.value  = value 
        }

        const getRenewalDate = computed( () => {
            if( subscription.value ){
                const expire = new Date(subscription.value.subscription.renewalDate )
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return expire.toLocaleDateString('es-ES', options)
            }
        })
        const expireMemberDate = computed(() => {
            if( subscription.value ){
                let expire = new Date(subscription.value.subscription.creationDate )
                let today =  new Date()
                let yearFromDate = expire.getFullYear();
                let monthFromYear = expire.getMonth();
                let dayFromYear = expire.getDate();
                let newDate = new Date(yearFromDate, monthFromYear  + 3, dayFromYear);
                isExpiredCompanions.value =  today.setHours(0,0,0,0) > newDate.setHours(0,0,0,0)
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                let newExpre = newDate.toLocaleDateString('es-ES', options)

                return newExpre
             }
        })


        const isExpiredToAddCompanions = computed(() => {
             if( subscription.value ){
                let expire = new Date(subscription.value.subscription.creationDate )
                let today =  new Date()
                let yearFromDate = expire.getFullYear();
                let monthFromYear = expire.getMonth();
                let dayFromYear = expire.getDate();
                let newDate = new Date(yearFromDate, monthFromYear  + 3, dayFromYear);
                let now =  today.setHours(0,0,0,0) > newDate.setHours(0,0,0,0)
        

                return now
             }
        })
        const getMemberSince = computed( () => {
             if( subscription.value ){
            
                const expire = new Date(subscription.value.subscription.creationDate )
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                 const lang = language.value  == 'es' ? 'es-ES' : 'en-US'
                return expire.toLocaleDateString(lang, options)
             
             }
        })

        const checkSubscription = () =>{
            if( !subscription.value ){
                router.push({name: 'Home'})
            }

            currentCompanions.value = subscription.value.subscription.companionsNumber
        }

        const getPlans = async () => {
            const currencyParameter = ( currency.value == 'MXN' ? `?currency=${currency.value}` : `?currency=${currency.value}`)
            await store.dispatch('getPlans', { currency: currencyParameter, useAuthToken : true }) 
        }
        
        watch( hasBilling, ( value ) => {
            console.log( value )
            isShow.value = !value 
        })

        const closeBilling = () => {
            isShow.value = !isShow.value
        }

          const initDataLayerCardView = () => {
                dataLayerViewCard( 'subscription information' )
                dataLayerViewCard( 'subscription settings' )
            }

        onMounted( async ()=> {

            if( !subscription.value ){
                let params = { plan: 'vfn' , continue : false} 
                if( Object.keys(store.state.Accounts.data).length == 0 ){
                    params.continue  = true
                }
                await store.dispatch('getSubscription', params )
            } else {
                await store.dispatch('getSubscription', {plan: 'vfn'} )
            }

          
             await getPlans()

           
    
            checkSubscription()
            initDataLayerCardView()
            
        })

        return { subscription, getRenewalDate, account, isShow, isExpiredCompanions, hasBilling, getMemberSince, expireMemberDate, closeBilling,dashboardTranslate, modalTranslation, language, isExpiredToAddCompanions, onShowModalActivate, showModalActive , currentCompanions, currentPlan}
    }
})
</script>

<style scoped>
.section-header {
	@apply text-3xl text-green-400 font-semibold md:font-bold;
}
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h5 {
    @apply md:text-sm text-green-400;
    font-size: 0.75rem;
}
input.form-control, select.form-control{
    @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 rounded-md pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
    @apply text-green-500 sm:text-xs;
}
.form-check-radio {
    @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
    @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}
.footer-content{
    @media (max-height: 930px) {
        position: relative;
    }
}
</style>